import { AnnotationType } from "@/state/UserAnnotations";
import { stateProperty, State, StateMap } from "@dodona/lit-state";
import { createStateFromInterface } from "@/state/CreateStateFromInterface";
import { submissionState } from "@/state/Submissions";

export interface MachineAnnotationData {
    type: AnnotationType;
    text: string;
    row: number;
    externalUrl?: string | null;
    format?: "plain" | "markdown";
    rows?: number;
    column?: number;
    columns?: number;
}

export class MachineAnnotation extends createStateFromInterface<MachineAnnotationData>() {
    @stateProperty public isHovered = false;
}

class MachineAnnotationState extends State {
    @stateProperty public byLine = new StateMap<number, MachineAnnotation[]>();
    @stateProperty public byMarkedLine = new StateMap<number, MachineAnnotation[]>();
    @stateProperty public count = 0;

    public setMachineAnnotations(annotations: MachineAnnotationData[]): void {
        this.count = annotations.length;
        this.byLine.clear();
        this.byMarkedLine.clear();
        for (const data of annotations) {
            const annotation = new MachineAnnotation(data);
            const markedLength = annotation.rows ?? 1;
            let line = annotation.row ? annotation.row + markedLength : 1;

            // show annotation on the last line if it is out of range
            if (line > submissionState.codeByLine.length) {
                line = submissionState.codeByLine.length;
            }

            if (this.byLine.has(line)) {
                this.byLine.get(line)?.push(annotation);
            } else {
                this.byLine.set(line, [annotation]);
            }
            for (let i = 1; i <= markedLength; i++) {
                const markedLine = annotation.row + i;
                if (this.byMarkedLine.has(markedLine)) {
                    this.byMarkedLine.get(markedLine)?.push(annotation);
                } else {
                    this.byMarkedLine.set(markedLine, [annotation]);
                }
            }
        }
    }
}

export const machineAnnotationState = new MachineAnnotationState();
